const { listenForIncantation } = require("./lib/key-incantation")
const { pride } = require("./pride/pride")

listenForIncantation("pride", pride)
listenForIncantation("proud", pride)
